/**
 * ユーザーに関する定数
 */

/**
 * ユーザーロール
 */
export const ROLES = {
  GENERAL: 'general',
  STAFF: 'staff',
  SHARED_DEVICE: 'shared_device',
} as const;

export type UserRole = (typeof ROLES)[keyof typeof ROLES];

/**
 * ページアクセスに許可されるロールの組み合わせ
 */
export const ALLOWED_ROLES = {
  // 共有端末用ページにアクセス可能なロール
  SHARED_DEVICE_PAGES: ['shared_device', 'staff'] as const,
} as const;

/**
 * 会員種別
 */
export const MEMBERSHIP_TYPES = {
  ANA_LOUNGE: 'ana_lounge',
  SUITE_LOUNGE: 'suite_lounge',
} as const;

export type MembershipType =
  (typeof MEMBERSHIP_TYPES)[keyof typeof MEMBERSHIP_TYPES];
